import $store from 'STORE'
import { flyToGeom } from '@/helpers/map'

export const saveRegion = ({ city, module }) => {
  const config = JSON.parse(localStorage.getItem('regionConfig'))

  localStorage.setItem(
    'regionConfig',
    JSON.stringify({ ...(config || {}), [module]: city })
  )

  const commitName = $store.state.storeRelations[module]
  $store.commit(commitName, ['city', city])
}

export const setCity = ({ mapgl, city, module }) => {
  const availableCities = $store.state.availableCities
  const defaultCity = $store.state[module].city

  if (!availableCities.length) return

  const currentCity = city || defaultCity || availableCities[0]?.name

  if (mapgl) {
    const { bbox } = availableCities.find(item => item.name === currentCity)

    if (bbox) {
      flyToGeom({ mapgl, bbox, speed: 2 })
    } else {
      console.warn('There is no bbox')
    }
  }

  saveRegion({ city: currentCity, module })

  return currentCity
}
